import React, { useState } from "react";
import { Button } from "@kuda/ui";
import { LockKeyholeIcon } from "@kuda/ui/icons";
import { useMsal } from "@azure/msal-react";
import Loading from "../components/loading";

const SignIn = () => {
  const [loading, setLoading] = useState(false);
  const { instance } = useMsal();

  const handleSignIn = () => {
    setLoading(true);

    instance.loginRedirect({
      scopes: ["user.read"],
    });
  };

  return (
    <div className="mx-auto" style={{ maxWidth: 444 }}>
      {loading && <Loading open={loading} />}
      <div className="flex flex-col items-center justify-center" style={{ marginTop: 64 }}>
        <div className="mb-2 rounded-full bg-color-bg-brand-secondary-default p-3">
          <LockKeyholeIcon className="size-6 text-color-icon-brand-primary-default" />
        </div>
        <h1 className="font-heading text-xl font-bold">Sign in</h1>

        <div className="w-4/5" style={{ marginTop: 80 }}>
          <Button variant="filled" fullWidth onClick={handleSignIn}>
            Sign in with Azure AD
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
